/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Br_History_Key_Smoketemperature1Inputs */



/**
* | output |
* | --- |
* | "Smoke temperature" |
*
* @param {Br_History_Key_Smoketemperature1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const br_history_key_smoketemperature1 = /** @type {((inputs?: Br_History_Key_Smoketemperature1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Br_History_Key_Smoketemperature1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Smoke temperature")
	return /** @type {LocalizedString} */ ("Température de fumée")
});
export { br_history_key_smoketemperature1 as "br_history_key_smokeTemperature" }